import { Box, Text } from '@quintoandar-tokko/jopijs';
import Skeletons from '@/components/Skeletons/Skeletons';
import styles from './DashboardSectionTitle.module.scss';

export default function DashboardSectionTitle({
  children,
  loading = false,
  ...rest
}) {
  return (
    <Box className={styles.titleWrapper}>
      {loading ? (
        <Skeletons height={32} width={300} borderRadius={8} />
      ) : (
        <Text className={styles.title} {...rest}>
          {children}
        </Text>
      )}
    </Box>
  );
}
